// extracted by mini-css-extract-plugin
export var activeDot = "_2y-c";
export var buttonContainer = "_2y-9";
export var channelButton = "_2y-a";
export var clickable = "_2y-d";
export var content = "_2y-0";
export var contentFull = "_2y-2";
export var contentThird = "_2y-1";
export var contentWrapper = "_2y-7";
export var description = "_2y-5";
export var heightShort = "_2y-f";
export var image = "_2y-3";
export var imageContainer = "_2y-4";
export var selectButton = "_2y-e";
export var spinnerContainer = "_2y-b";
export var titleContent = "_2y-8";
export var titleWrapper = "_2y-6";